import React from 'react';
import PropTypes from 'prop-types';
import * as Styles from './index.styles';

const { StyledFormGroup } = Styles;

export const FormGroupContext = React.createContext();

export const FormGroup = ({ name, onChange, vertical, border, children, ...otherProps }) => {
    return (
        <StyledFormGroup vertical={vertical} border={border} {...otherProps}>
            <FormGroupContext.Provider value={{ name, onChange }}>
                {children}
            </FormGroupContext.Provider>
        </StyledFormGroup>
    );
};

FormGroup.propTypes = {
    name: PropTypes.string,
    fullWidth: PropTypes.bool,
    vertical: PropTypes.bool,
    border: PropTypes.bool,
    children: PropTypes.node,
    onChange: PropTypes.func,
};

/* istanbul ignore next */
FormGroup.defaultProps = {
    name: '',
    vertical: false,
    fullWidth: false,
    border: false,
    children: undefined,
    onChange: () => undefined,
};

FormGroup.Styles = Styles;
